// Flexible pay: the pay types a company may give someone, and how each is asked for. This add-on is off unless the
// server says so, so the check is a strict `=== true` (the usual "not false" test would show it to everyone).
const FIXED_ONLY = ["Fixed"];

const FORMULA_PAY_TYPES = [
  { value: "Fixed", label: "Fixed monthly" },
  { value: "Daily", label: "Per day" },
  { value: "Hourly", label: "Per hour" },
  { value: "Commission", label: "Commission" },
  { value: "Retainer", label: "Monthly fee" },
];

export const flexiblePayOn = (plugins) => (plugins || {})["payroll.formulas"] === true;

// What the pay type select offers: Fixed alone for a company without the add-on, otherwise all five.
export const payTypeOptions = (plugins) => (flexiblePayOn(plugins) ? FORMULA_PAY_TYPES : FIXED_ONLY);

export const payTypeLabel = (value) => FORMULA_PAY_TYPES.find((t) => t.value === value)?.label || value || "—";

// What the pay figure on the form means for each type.
const RATE_LABELS = {
  Fixed: "Base Pay (₹)",
  Daily: "Pay for each day (₹)",
  Hourly: "Pay for each hour (₹)",
  Commission: "Fixed part each month (₹)",
  Retainer: "Monthly fee (₹)",
};
export const rateLabel = (payType) => RATE_LABELS[payType] || RATE_LABELS.Fixed;

// The numbers entered each month for a pay type: [kind, label].
const ENTRY_KINDS = {
  Daily: [["days", "Days worked"]],
  Hourly: [["hours", "Hours worked"], ["overtime_hours", "Overtime hours"]],
  Commission: [["achieved_amount", "Amount achieved (₹)"]],
};
export const entryKindsFor = (payType) => ENTRY_KINDS[payType] || [];

// A number that went into a figure, as a phrase: "160 hours worked", "₹1,50,000 achieved". The key is the server's.
const UNIT_PHRASES = {
  days: (n) => `${n} ${n === "1" ? "day" : "days"} worked`,
  hours: (n) => `${n} ${n === "1" ? "hour" : "hours"} worked`,
  overtime_hours: (n) => `${n} overtime ${n === "1" ? "hour" : "hours"}`,
  achieved_amount: (n) => `₹${n} achieved`,
};
export function unitPhrase(kind, value) {
  const n = Number(value).toLocaleString("en-IN");
  return (UNIT_PHRASES[kind] || ((count) => `${count} ${String(kind).replace(/_/g, " ")}`))(n);
}

// The rest of a pay profile that only some types use.
export const needsTaxRule = (payType) => payType === "Retainer";
export const needsCommissionPlan = (payType) => payType === "Commission";

// The fields posted with a pay profile: a type never carries what it does not use.
export function formulaFields(form) {
  const type = form.pay_type || "Fixed";
  return {
    tax_rule: needsTaxRule(type) && form.tax_rule ? Number(form.tax_rule) : null,
    pan_on_file: needsTaxRule(type) ? Boolean(form.pan_on_file) : false,
    commission_plan: needsCommissionPlan(type) && form.commission_plan ? Number(form.commission_plan) : null,
  };
}
